module.exports = __webpack_public_path__ + "img/logo.c3c08649.png";